"use client"

import { NotFound } from "pages"

export default function NotFoundPage() {
  return <NotFound />
}
